// Bibliotecas
import React from 'react';
import cn from 'classnames';

import OptionItem from './OptionItem/OptionItem'; // Componentes
import './Options.css'; // CSS

class Options extends React.Component {
    constructor(props){
        super(props);

        this.toTabsName = {
            weights: "Tamanho",
            fillings: "Recheio",
            packings: "Embrulho",
            surprises: "Surpresa",
            egg: "Ovo",
        };

        this.optionsNames = this.getOptionsNames(props.options);
        this.state = {sliderIndex: 0};
    }

    getOptionsNames = (options) => {
        const optionsNames = [];

        for(let p in options)
            optionsNames.push(p);
        
        return optionsNames;
    }

    sliderTo = (sliderIndex) => {
        const optionName = this.optionsNames[sliderIndex];
        const option = this.props.options[optionName];
        
        if(this.hasOptionMarked(option)) this.setState({sliderIndex});
    }

    sliderToAvailable = () => {
        const {sliderIndex} = this.state;
        const {options} = this.props;
        
        for(let i=0; i<this.optionsNames.length; i++){
            const option = options[this.optionsNames[i]];

            if(i != sliderIndex && !this.hasOptionMarked(option)){
                this.setState({sliderIndex: i});
                break;
            }
        }
    }

    hasOptionMarked = (option) => {
        return option.values.find(opt => opt.mark);
    }

    hasAllOptionMarked = () => {
        const optionsNames = this.optionsNames;

        for(let i=0; i<optionsNames.length; i++){
            const option = this.props.options[optionsNames[i]];
            if(!this.hasOptionMarked(option)) return false;
        }

        return true;
    }

    markOption = (id, optionName) => {
        this.props.onMarkOption(id, optionName);
        
        setTimeout(this.sliderToAvailable, 250);
        
        if(this.hasAllOptionMarked()) this.props.onComplete();
    }
    
    render(){
        const {sliderIndex} = this.state;
        const {options} = this.props;
        const sliderInnerStyle = {left: `${-100 * sliderIndex}%`};

        return (
            <div className="options">
                <div className="options__tabs">
                    {this.optionsNames.map((optionName, index) => {
                        const tabName = this.toTabsName[optionName];
                        
                        return (
                            <div
                                className={cn("options__tab", {"options__tab--active": sliderIndex == index})}
                                onClick={() => this.sliderTo(index)}>
                                {tabName}
                            </div>
                        )
                    })}
                </div>

                <div className="options__slider">
                    <div className="options__slider-inner" style={sliderInnerStyle}>
                        {this.optionsNames.map(optionName => {
                            const option = options[optionName];
                            
                            return (
                                <div className="options__slider-item options__slider-item--mult">
                                    {this.props.showPackingDescription && option.description !== null ? (
                                        <p className="options__slider-description">
                                            {option.description}
                                        </p>
                                    ) : null}

                                    {option.values.map(opt => (
                                        <OptionItem
                                            id={opt.id}
                                            value={opt.value}
                                            mark={opt.mark}
                                            onClick={() => this.markOption(opt.id, optionName)} />
                                    ))}
                                </div>
                            )
                        })}
                    </div>
                </div>
            </div>
        );
    }
}

export default Options;